import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    try {
      // Get API base URL and construct OAuth endpoint
      let apiBaseUrl = process.env.REACT_APP_API_URL;
      
      // Clean and validate the URL
      if (apiBaseUrl) {
        apiBaseUrl = apiBaseUrl.trim();
        // Remove leading dots (fix for malformed URLs like ".ai-mcp-bio.com")
        if (apiBaseUrl.startsWith('.')) {
          apiBaseUrl = apiBaseUrl.substring(1);
        }
      }
      
      // Fallback: if env var is not set or invalid, try to detect from current location
      if (!apiBaseUrl || (!apiBaseUrl.startsWith('http://') && !apiBaseUrl.startsWith('https://'))) {
        // In production, use the known backend URL
        if (window.location.hostname === 'ai-mcp-bio.com' || window.location.hostname.includes('ai-mcp-bio.com')) {
          apiBaseUrl = 'https://api.ai-mcp-bio.com/api';
        } else {
          // Development fallback
          apiBaseUrl = 'http://localhost:8001/api';
        }
      }
      
      // Normalize the URL: ensure it's a valid absolute URL
      // Remove trailing slashes and /api suffix if present
      apiBaseUrl = apiBaseUrl.replace(/\/+$/, '').replace(/\/api$/, '');
      
      // Ensure it starts with http:// or https://
      if (!apiBaseUrl.startsWith('http://') && !apiBaseUrl.startsWith('https://')) {
        // If it's a relative URL, make it absolute
        if (apiBaseUrl.startsWith('/')) {
          apiBaseUrl = `${window.location.protocol}//${window.location.host}${apiBaseUrl}`;
        } else {
          // Remove any leading dots again (safety check)
          if (apiBaseUrl.startsWith('.')) {
            apiBaseUrl = apiBaseUrl.substring(1);
          }
          // Assume https for production, http for localhost
          const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
          apiBaseUrl = `${protocol}://${apiBaseUrl}`;
        }
      }
      
      // Final validation: ensure no double dots or malformed URLs
      if (apiBaseUrl.includes('/.')) {
        apiBaseUrl = apiBaseUrl.replace(/\/\./g, '/');
      }
      
      // Construct OAuth URL
      const oauthUrl = `${apiBaseUrl}/api/auth/google`;
      
      console.log('Redirecting to Google OAuth:', oauthUrl);
      window.location.href = oauthUrl;
    } catch (error) {
      console.error('Error in handleGoogleLogin:', error);
      setError('Failed to initiate Google login. Please try again.');
    }
  };

  const handleGitHubLogin = () => {
    try {
      // Get API base URL and construct OAuth endpoint
      let apiBaseUrl = process.env.REACT_APP_API_URL;
      
      // Clean and validate the URL
      if (apiBaseUrl) {
        apiBaseUrl = apiBaseUrl.trim();
        // Remove leading dots (fix for malformed URLs like ".ai-mcp-bio.com")
        if (apiBaseUrl.startsWith('.')) {
          apiBaseUrl = apiBaseUrl.substring(1);
        }
      }
      
      // Fallback: if env var is not set or invalid, try to detect from current location
      if (!apiBaseUrl || (!apiBaseUrl.startsWith('http://') && !apiBaseUrl.startsWith('https://'))) {
        // In production, use the known backend URL
        if (window.location.hostname === 'ai-mcp-bio.com' || window.location.hostname.includes('ai-mcp-bio.com')) {
          apiBaseUrl = 'https://api.ai-mcp-bio.com/api';
        } else {
          // Development fallback
          apiBaseUrl = 'http://localhost:8001/api';
        }
      }
      
      // Normalize the URL: ensure it's a valid absolute URL
      // Remove trailing slashes and /api suffix if present
      apiBaseUrl = apiBaseUrl.replace(/\/+$/, '').replace(/\/api$/, '');
      
      // Ensure it starts with http:// or https://
      if (!apiBaseUrl.startsWith('http://') && !apiBaseUrl.startsWith('https://')) {
        // If it's a relative URL, make it absolute
        if (apiBaseUrl.startsWith('/')) {
          apiBaseUrl = `${window.location.protocol}//${window.location.host}${apiBaseUrl}`;
        } else {
          // Remove any leading dots again (safety check)
          if (apiBaseUrl.startsWith('.')) {
            apiBaseUrl = apiBaseUrl.substring(1);
          }
          // Assume https for production, http for localhost
          const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
          apiBaseUrl = `${protocol}://${apiBaseUrl}`;
        }
      }
      
      // Final validation: ensure no double dots or malformed URLs
      if (apiBaseUrl.includes('/.')) {
        apiBaseUrl = apiBaseUrl.replace(/\/\./g, '/');
      }
      
      // Construct OAuth URL
      const oauthUrl = `${apiBaseUrl}/api/auth/github`;
      
      console.log('Redirecting to GitHub OAuth:', oauthUrl);
      window.location.href = oauthUrl;
    } catch (error) {
      console.error('Error in handleGitHubLogin:', error);
      setError('Failed to initiate GitHub login. Please try again.');
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '400px', margin: '2rem auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Login</h2>
        
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {/* Google Login Button */}
        <button
          type="button"
          onClick={handleGoogleLogin}
          className="btn"
          style={{
            width: '100%',
            marginBottom: '1rem',
            backgroundColor: '#4285f4',
            color: 'white',
            border: 'none',
            padding: '0.75rem',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            fontSize: '1rem',
            fontWeight: '500'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#357ae8'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#4285f4'}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
              <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.348 6.173 0 7.55 0 9s.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
            </g>
          </svg>
          Sign in with Google
        </button>

        {/* GitHub Login Button */}
        <button
          type="button"
          onClick={handleGitHubLogin}
          className="btn"
          style={{
            width: '100%',
            marginBottom: '1.5rem',
            backgroundColor: '#24292e',
            color: 'white',
            border: 'none',
            padding: '0.75rem',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            fontSize: '1rem',
            fontWeight: '500'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1a1e22'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#24292e'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          Sign in with GitHub
        </button>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          margin: '1.5rem 0',
          textAlign: 'center'
        }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
          <span style={{ padding: '0 1rem', color: '#666' }}>OR</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-input"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <p>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: '#007bff' }}>
              Register here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
